// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.theme-switcher-filter {\n    flex: 100;\n    max-width: 15em;\n    min-width: 0;\n    font-weight: normal;\n    padding: 0.25em;\n    margin: 0 0.5em;\n    color: #595959;\n}\n", ""]);
// Exports
module.exports = exports;
